// import "bootstrap/dist/css/bootstrap.min.css";
// import { useNavigate } from "react-router-dom";
import { useTheme } from "./ThemeContext";
import brochure1 from './imeges/brochure1.png';
import brochure2 from './imeges/brochure2.png';
import brochure3 from './imeges/brochure3.jpeg';
import Lims from './BrochersPdfs/BBT_Blood Bank.pdf';
import BloodBank from "./BrochersPdfs/BBT_LIMS.pdf";
import QualtityControl from "./BrochersPdfs/BBT_QC_Brochure.pdf";
import HealthCare from './BrochersPdfs/video/HealthCare.mp4'
import { useRef } from "react";
const HealthcareBrochures = () => {
  // const navigate = useNavigate();
  const { theme } = useTheme();
    const videoRef = useRef(null);

  // Brochure data
  const brochures = [
    {
      type : "pdf",
      title: "QUALITY CONTROL MODULE",
      subtitle: "BBT LABS-QC",
      description: "Connecting the dots",
      imgSrc: brochure1,
      pdfPath:  QualtityControl, // ✅ Your first brochure PDF
      pdfName: 'BBT_QC_Brochure.pdf',
    },
    {
      type : "pdf",
      title: "LABORATORY INFORMATION SYSTEM",
      subtitle: "BBT LABS",
      description: "Connecting the dots",
      imgSrc: brochure3,
      pdfPath: BloodBank, // ✅ Your second brochure PDF
      pdfName: 'BBT_BloodBank_Brochure.pdf',
    },
    {
      type : "pdf",
      title: "BBT Labs-Blood Bank Module",
      subtitle: "",
      description: "Manage your Blood Bank Workflow with 100% reliability at each step",
      imgSrc: brochure2,
      pdfPath: Lims ,// ✅ Your third brochure PDF
      pdfName: 'BBT_Lims_Brochure.pdf',
    },
    {
      type : "video",
      title: "HealthCare Clinic",
      subtitle: "",
      description: "Manage your Blood Bank Workflow with 100% reliability at each step",
      imgSrc: brochure2,
      videoUrl: HealthCare // inside public/videos/myvideo.mp4
    },
  ];
const videoElement = document.getElementById("my-video");

if (videoElement) {
  if (videoElement.paused) {
    videoElement.play().catch((error) => {
      console.error("Error playing the video:", error);
    });
  } else {
    videoElement.pause();
  }
}
//  else {
//   console.error("Video element not found!");
// }

  // Function to download PDF
const handleClick = (item) => {
  if (item.type === "pdf") {
    const link = document.createElement('a');
    link.href = item.pdfPath;
    link.download = item.pdfName;
    link.click();
  } else if (item.type === "video") {
     
     if (videoRef.current) {
        videoRef.current.currentTime = 0;        // ⬅️ Start from 0 seconds
        videoRef.current.requestFullscreen();    // ⬅️ Fullscreen
        videoRef.current.play();                   // ⬅️ Start playing
      }
    // window.open(item.videoUrl, "_blank"); // Open video in new tab
  }
};

  return (
    <div style={{ backgroundColor: theme === "dark" ? "#1e1e1e" : "", width: '100%' }}>
      {/* Hero Section */}
      <section className="text-center pt-5">
        <h2 className="fw-bold mb-4">Best Healthcare Brochures & Lab Systems.</h2>
        <div className="d-flex justify-content-center gap-3 mb-4">
          <button
            className="btn btn-outline-light px-4 shadow rounded text-white"
            // onClick={() => navigate("/book-demo")}
            style={{ backgroundColor: '#001351' }}
          >
            Book For Demo
          </button>
          <button
            className="btn btn-outline-light px-4 shadow rounded text-white"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            style={{ backgroundColor: '#001351' }}
          >
            Contact Us
          </button>
        </div>
      </section>

      {/* Brochures Section */}
      <section className="text-center pb-5" style={{ backgroundColor: theme === "dark" ? "#1e1e1e" : "" }}>
        <h2 className="fw-bold mb-4">Brochures</h2>
        <div className="container mt-4">
          <div className="row row-cols-1 row-cols-md-3 g-4 justify-content-center">
            {brochures.map((brochure, index) => (
              <div className="col-md-3" key={index}>
                <div
                  className="card bg-white text-black h-100 shadow-lg"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleClick(brochure)}
                >
                  {brochure.type === 'pdf'?(
                  <img src={brochure.imgSrc} className="card-img-top" alt="Brochure" loading="lazy" />
                  ):  
                  
                  (<video
                  my-video = "true"
                  ref={videoRef}
                  src={brochure.videoUrl}
                  width="100%"
                  height="auto"
                  muted
                   autoPlay
                  
                  loop
                  playsInline
                  preload="metadata"
                  style={{ borderRadius: '10px' }}
                  controls={false}     // no controls until fullscreen
                  // muted
                  // poster={brochure.imgSrc} 
                  // optional preview image
                />)
                
                }
                  {/* <div className="card-body">
                    <h5 className="card-title fw-bold">{brochure.title}</h5>
                    <h6 className="card-subtitle" style={{ color: '#001351' }}>{brochure.subtitle}</h6>
                    <p className="card-text">{brochure.description}</p>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HealthcareBrochures;
